export default {
  setSmtpDetails: (state, smtpDetails) => (state.smtp = smtpDetails)
};
